import { Module } from "vuex";
import { RootState } from "../types";
import { AnalysesState } from "./types";
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export const analyses: Module<AnalysesState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
